export const AdminSystemLogsController = {
    index(): void {},
};
